<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M13.468 11.4404L15.5057 13.4774L9.991 18.9921L4.477 13.4781L6.51475 11.4404L9.99175 14.9354L13.468 11.4404ZM16.9457 7.96337L19 10.0004L16.9637 12.0374L14.926 10.0004L16.9457 7.96337ZM9.99175 7.96337L12.0287 9.98237L9.991 12.0201L7.954 10.0004L9.991 7.96412L9.99175 7.96337ZM3.037 7.96337L5.0575 10.0004L3.0385 12.0194L1 10.0004L3.037 7.96337ZM9.9925 1.00787L15.5065 6.50537L13.4688 8.54162L9.99175 5.06462L6.5155 8.55962L4.47775 6.52262L9.99175 1.00862L9.9925 1.00787Z"
            fill="#F3BA2F"
        />
    </svg>
</template>
